import {DurationType} from '../enum/duration-type.enum';
import {FrequencyType} from '../enum/frequency-type.enum';
import {Gender} from '../enum/gender.enum';

export interface SmokeHabit
{
    state?: boolean;
    amount?: number;
    since?: {
        durationType?: DurationType;
        value?: number;
    };
}

export interface DrinkOrSportHabit
{
    state?: boolean;
    amount?: number;
    frequency?: FrequencyType;
}

interface HealthConditions
{
    diseases?: {
        state?: boolean;
        list?: string;
    };
    allergies?: {
        state?: boolean;
        list?: string;
    };
    medications?: {
        state?: boolean;
        list?: string;
    };
}

export interface Contact
{
    code: string;
    number: string;
}

interface Practices
{
    smoke?: SmokeHabit;
    drink?: DrinkOrSportHabit;
    sport?: DrinkOrSportHabit;
}

export class Patient
{
    public readonly id: string;

    public readonly email: string;

    public readonly firstName?: string;

    public readonly lastName?: string;

    public readonly picture?: string;

    public readonly gender?: Gender;

    public readonly weight?: number;

    public readonly height?: number;

    public readonly age?: number;

    public readonly address?: string;

    public readonly zipCode?: string;

    public readonly city?: string;

    public readonly location?: string;

    public readonly jobPosition?: string;

    public readonly contact?: Contact;

    public readonly practices?: Practices;

    public readonly healthConditions?: HealthConditions;

    public constructor(
        id: string,
        email: string,
        firstName?: string,
        lastName?: string,
        picture?: string,
        gender?: Gender,
        weight?: number,
        height?: number,
        age?: number,
        address?: string,
        city?: string,
        location?: string,
        jobPosition?: string,
        contact?: Contact,
        practices?: Practices,
        healthConditions?: HealthConditions
    )
    {
        this.id = id;
        this.email = email;
        this.firstName = firstName;
        this.lastName = lastName;
        this.picture = picture;
        this.gender = gender;
        this.weight = weight;
        this.height = height;
        this.age = age;
        this.address = address;
        this.city = city;
        this.location = location;
        this.jobPosition = jobPosition;
        this.contact = contact;
        this.practices = practices;
        this.healthConditions = healthConditions;
    }

    public static fromJSON(patientJSON: any): Patient
    {
        return new Patient(
            patientJSON.id,
            patientJSON.email,
            patientJSON.firstName,
            patientJSON.lastName,
            patientJSON?.picture ?? 'assets/images/avatar_placeholder.webp',
            patientJSON.gender,
            patientJSON.weight,
            patientJSON.height,
            patientJSON.birthDate ?
                Math.floor((new Date().getTime() - new Date(patientJSON.birthDate).getTime()) / (365.25 * 24 * 60 * 60 * 1000)) :
                undefined,
            patientJSON.address,
            patientJSON.city,
            patientJSON.location,
            patientJSON.jobPosition,
            patientJSON.contact,
            patientJSON.practices ? {
                smoke: {
                    state: !!patientJSON.practices.smoke?.state,
                    ...patientJSON.practices.smoke
                },
                drink: {
                    state: !!patientJSON.practices.drink?.state,
                    ...patientJSON.practices.drink
                },
                sport: {
                    state: !!patientJSON.practices.sport?.state,
                    ...patientJSON.practices.sport
                }
            } : undefined,
            patientJSON.healthConditions
        );
    }
}
